export default __webpack_public_path__ + "static/media/sd-banner-3.2d2249a6.jpg";